function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M132.815 121.159c0 4.594-7.122 10.813-15.907 10.813-8.786 0-15.908-6.219-15.908-10.813 0 0 7.122-4.159 15.908-4.159 8.785 0 15.907 4.159 15.907 4.159z",
  fill: "#5F3460"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M123 130.5c0 3.038-2.686 5.5-6 5.5s-6-2.462-6-5.5 2.686-5.5 6-5.5 6 2.462 6 5.5z",
  fill: "#ED313C"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M129.372 119.542a3.744 3.744 0 01-3.725 3.374h-16.844a3.744 3.744 0 01-3.741-3.615c2.913-1.108 7.141-2.301 11.845-2.301 5.05 0 9.551 1.374 12.465 2.542z",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M96.632 87.626c7.155.613 10.787 7.002 12.063 9.889l-1.712.756c-1.246-2.819-4.481-8.264-10.51-8.78-5.463-.469-8.735 1.68-11.013 3.176-.292.191-.567.372-.829.535l-.99-1.588c.239-.149.499-.32.781-.507 2.297-1.515 6.074-4.007 12.21-3.481zm41.085-.023c-7.176.283-11.097 6.498-12.505 9.323l1.676.835c1.374-2.76 4.856-8.05 10.903-8.288 5.478-.217 8.648 2.08 10.855 3.68.282.204.549.397.803.572l1.063-1.54c-.232-.16-.484-.344-.758-.543-2.224-1.62-5.883-4.282-12.037-4.04z",
  fill: "#212121"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M87.54 81.472a.832.832 0 01.123-.149C89.323 79.775 94.004 79 96.36 79c2.247 0 5.902 0 7.656 1.323.217.163.348.41.414.672a2.243 2.243 0 01-2.176 2.786H88.775c-1.186 0-1.894-1.322-1.236-2.309zm57.429.184c-1.594-1.86-7.172-2.656-9.563-2.656-2.311 0-6.112 0-7.082 1.44a1.024 1.024 0 00-.133.326 2.427 2.427 0 002.354 3.015h13.361c1.095 0 1.719-1.25 1.063-2.125z",
  fill: "#212121"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M111 130h12v6a6 6 0 11-12 0v-6z",
  fill: "#ED313C"
});

function SvgFace4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 232,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
}

export default __webpack_public_path__ + "static/media/face-4.78212bb0.svg";
export { SvgFace4 as ReactComponent };